export default "__VITE_ASSET__D$taoGOm__"